import React, { createContext, useContext, useState, useEffect } from "react";
import { fetchCompanyDetails } from "../api/CompanyDetailsApi";
import { useAllDataContext } from "./AllDataContext";
import { fetchAllData } from "../components/FetchAllApi";

const CompanyDetailsContext = createContext({
  companyDetailsData: [],
  setCompanyDetailsData: () => null,
});

export const useCompanyDetailsContext = () => useContext(CompanyDetailsContext);

export const CompanyDetailsProvider = ({ children }) => {
  const [companyDetailsData, setCompanyDetailsData] = useState([]);
  const { setAllData } = useAllDataContext();

  // Fetch company details and populate global allData on app mount / refresh
  useEffect(() => {
    if (companyDetailsData.length === 0) {
      Promise.all([fetchCompanyDetails()])
        .then(([companyDetails]) => {
          setCompanyDetailsData(companyDetails);
        })
        .catch(() => {
          console.error("Server Error");
        });
    }
    // Also trigger fetchAllData to populate other shared data.
    fetchAllData({ companyDetailsData, setAllData });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyDetailsData.length]);

  return (
    <CompanyDetailsContext.Provider
      value={{ companyDetailsData, setCompanyDetailsData }}
    >
      {children}
    </CompanyDetailsContext.Provider>
  );
};
